import { IconIsolationMode } from 'assets/img';
import { HqShiftPlanningCellProps } from 'shared/components/planner/shifts/table/shift-planning-table.types';
import type { Column } from 'react-table';
import {
  BoxAction,
  BoxIcon,
  Cell,
  DateTimeCell,
  Header,
  JobNameCell,
  PartnersCell,
} from 'shared/components/planner/common/utils';
import { TFunctionNonStrict } from 'i18next';
import { CandidatePlacementsCellWithTooltip } from 'shared/components/planner/shifts/placements-tooltip/candidate-placements-cell-with-tooltip';
import {
  HqShiftPlanningApplicationColumnDefinition,
  HqShiftPlanningCellProp,
} from '../shift-planning-table.types';
import { ApplicationsCellWithTooltip } from '../../../common/applications-tooltip/applications-cell-with-tooltip';

const getShiftPlanningApplicationColumnDefinition: (
  t: TFunctionNonStrict<'hq-screen-specific', undefined>
) => Column<HqShiftPlanningApplicationColumnDefinition>[] = (t) => {
  const jobName = {
    Header: () => (
      <Header>{t('shifts.table_headers.job_title', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'jobName',
    Cell: JobNameCell,
    width: '200px',
  } as Column<HqShiftPlanningApplicationColumnDefinition>;
  const companyName = {
    Header: () => (
      <Header>{t('shifts.table_headers.company', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'companyName',
    Cell: Cell,
    width: '200px',
  } as Column<HqShiftPlanningApplicationColumnDefinition>;
  const departmentName = {
    Header: () => (
      <Header>{t('shifts.table_headers.department', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'departmentName',
    Cell: Cell,
    width: '350px',
  } as Column<HqShiftPlanningApplicationColumnDefinition>;
  const dateTime = {
    Header: () => (
      <Header>{t('shifts.table_headers.date_time', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'dateTime',
    Cell: DateTimeCell,
    width: '230px',
  } as Column<HqShiftPlanningApplicationColumnDefinition>;
  const candidatePlacements = {
    Header: () => (
      <Header>{t('shifts.table_headers.placements', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'candidatePlacements',
    Cell: PartnerPlacementsTooltipCell,
    width: '110px',
  } as Column<HqShiftPlanningApplicationColumnDefinition>;
  const applications = {
    Header: () => (
      <Header>{t('shifts.table_headers.applications', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'applications',
    Cell: ApplicationsCell,
    width: '150px',
  } as Column<HqShiftPlanningApplicationColumnDefinition>;
  const partners = {
    Header: () => (
      <Header>{t('shifts.table_headers.partners', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'partners',
    Cell: PartnersCell,
    width: '85px',
  } as Column<HqShiftPlanningApplicationColumnDefinition>;
  const action = {
    Header: () => <Header>{t('shifts.table_headers.action', { ns: 'hq-screen-specific' })}</Header>,
    accessor: 'action',
    Cell: ActionCell,
    width: '65px',
  } as Column<HqShiftPlanningApplicationColumnDefinition>;

  return [
    jobName,
    companyName,
    departmentName,
    dateTime,
    candidatePlacements,
    applications,
    partners,
    action,
  ];
};

const ActionCell = (props: HqShiftPlanningCellProp<'action'>) => {
  return (
    <BoxAction>
      <BoxIcon>
        <IconIsolationMode onClick={() => props.onShowDetail(props.value)} />
      </BoxIcon>
    </BoxAction>
  );
};

const PartnerPlacementsTooltipCell = (props: HqShiftPlanningCellProp<'candidatePlacements'>) => {
  return <CandidatePlacementsCellWithTooltip {...props} />;
};

const ApplicationsCell = (props: HqShiftPlanningCellProps<'applications'>) => {
  return <ApplicationsCellWithTooltip {...props} />;
};

export { getShiftPlanningApplicationColumnDefinition };
